import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled(Form)`
  width: 100%;

  display: flex;
  flex-direction: column;

  > div + div {
    margin-top: 1rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;

export const TanquesAlarmes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
`;

export const TanqueAlarme = styled.div`
  padding: 0.75rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
`;

export const TanqueHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;

  strong {
    font-size: 0.875rem;
    font-weight: 500;
  }
`;
